export function techReducer(state = "",{
    type,
    payload
}){
    
    switch(type){
        case "GET_ALL_TECH_STATS":            
            return payload;
        
        case "GET_TECH_STATS":            
            return {[payload.techID] : payload.stats, ...state};
        
        default:
            return state;
    }
    
}